// © Microsoft Corporation. All rights reserved.

import { ExperienceLoadingState } from "./ExperienceLoadingState";

/**
 * Defines custom deferral event types which is not part of page/experience lifecycle event types
 */
export enum CustomDeferralEventTypes {

    /**
     * The page level milestone when experiences outside the viewport are transitioning into viewport
     */
    belowTheFoldTransitionStart
}

/**
 * Defines valid deferral events used during milestone tracking
 * The event types should be mapped with loading types so that they have the exact same numeric value.
 */
export enum ExperienceDeferralEventTypes {
    /**
     * The startLoading milestone of dependent experience
     */
    startLoading = ExperienceLoadingState.startLoading,
    /**
     * The loaded milestone of dependent experience
     */
    loaded = ExperienceLoadingState.loaded,
    /**
     * The rendered milestone of dependent experience
     */
    rendered = ExperienceLoadingState.rendered,
    /**
     * The domComplete milestone of dependent experience
     */
    domComplete = ExperienceLoadingState.domComplete,
    /**
     * The visuallyReady milestone of dependent experience
     */
    visuallyReady = ExperienceLoadingState.visuallyReady,
    /**
     * The page level milestone when experiences in viewport are visuallyReady
     */
    aboveTheFoldVisuallyReady,
    /**
     * The page level milestone when experiences outside the viewport are transitioning into viewport
     */
    belowTheFoldTransitionStart = CustomDeferralEventTypes.belowTheFoldTransitionStart,
    /**
    * The page level milestone when hydration has completed
    */
    hydrationComplete
}

/**
 * Helper to lookup the equivalent deferrel event type given the experience loadings state
 */
export const ExperienceLoadingStateToDeferralEventType = new Map([
    [ExperienceLoadingState.loaded, ExperienceDeferralEventTypes.loaded],
    [ExperienceLoadingState.rendered, ExperienceDeferralEventTypes.rendered],
    [ExperienceLoadingState.domComplete, ExperienceDeferralEventTypes.domComplete],
    [ExperienceLoadingState.visuallyReady, ExperienceDeferralEventTypes.visuallyReady]
]);